import { Checkbox } from 'antd';
import styles from './assets/ChecklistStyles.scss';
import { ICheckboxGroupProps, ICheckboxListProps } from './entities';

import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

const CheckboxGroup = Checkbox.Group;

const BCCheckboxGroup = (props: ICheckboxGroupProps) => {
	const getOptions = (options: Array<ICheckboxListProps>) => {
		if (!options) {
			return null;
		}

		const classNames = cx({
			vertical: props.mode === 'vertical',
			horizontal: props.mode === 'horizontal'
		});

		return options.map((item, i) => (
			<Checkbox
				key={item.key}
				className={classNames}
				style={props.style}
				value={item.value}
				disabled={item.disabled}
			>
				{item.label}
			</Checkbox>
		));
	};

	return (
		<CheckboxGroup
			defaultValue={props.defaultValue}
			onChange={props.onChange}
			style={props.style}
			disabled={props.disabled}
			className={props.className}
			value={props.value}
		>
			{getOptions(props.options)}
		</CheckboxGroup>
	);
};
export default BCCheckboxGroup;

export { ICheckboxGroupProps, ICheckboxListProps };
